import "bootstrap";
import "../src/js/stimulus.js";
import "../src/js/rails-min-ujs.js";
import "../src/js/survey.js";
import "../src/js/device-monitor-toggle.js";
import "../src/js/question-form.js";
import "../src/js/membership-reportable.js";
import "../src/js/deeplink-tab.js";
//= require number_with_delimiter
//= require multi-dash

document.addEventListener("DOMContentLoaded", function () {
  const elm = document.getElementById("q_name_cont");
  if (elm) elm.focus();
});
